@let filteredItems = filteredOptions$ | async;
<div #inputElement class="input-wrapper desktop" (click)="onInputClick()">
  <ng-container *ngTemplateOutlet="inputTemplate" />
</div>

<div class="d-flex d-md-none input-wrapper" (click)="showMobileModal()">
  <ng-container *ngTemplateOutlet="inputTemplate" />
</div>

<ng-template #inputTemplate>
  <ds-input
    [formControl]="formControl"
    [placeholder]="props.placeholder"
    [leadingIcon]="leadingIcon"
    [invalid]="formControl.touched && !!formControl.errors"
    [inputId]="id"
    autocomplete="off"
    data-id="autocomplete-input"
  />
</ng-template>

<ng-template #dropdownTemplate>
  <div
    (click)="updateOverlayPosition()"
    class="dropdown"
    [class.scrollable]="filteredItems?.length"
  >
    @if (filteredItems?.length) {
      <cdk-virtual-scroll-viewport
        class="h-100"
        [class.scrollable]="isScrollable"
        [ngStyle]="{
          height: filteredItems?.length ? dropdownHeight + 'px' : maxDropdownHeight + 'px',
          maxHeight: filteredItems?.length ? dropdownHeight + 'px' : maxDropdownHeight + 'px',
        }"
        customVirtualScroll
        [heights]="heights"
        [paddingBottom]="4"
        [paddingTop]="4"
      >
        <div
          data-id="autocomplete-group"
          *cdkVirtualFor="let item of filteredItems; trackBy: trackByItemFn; let isLast = last"
          class="d-flex g-1 flex-column dropdown-group pt-1 pb-1"
          [class.with-border]="!isLast"
        >
          @if (item.groupData && item.options.length > 1) {
            <div data-id="autocomplete-group-header" class="dropdown-group-item">
              <input-field-with-autocomplete-option [option]="item.groupData" />
            </div>
          }
          @for (option of item.options; track trackByOptionFn(option)) {
            <div data-id="autocomplete-group-option" class="dropdown-group-item enabled">
              <input-field-with-autocomplete-option
                [option]="option"
                (click)="selectOption(option)"
              />
            </div>
          }
        </div>
      </cdk-virtual-scroll-viewport>
    } @else {
      <div
        data-id="autocomplete-empty"
        [ngStyle]="{ height: maxDropdownHeight + 'px', maxHeight: maxDropdownHeight + 'px' }"
        (click)="closeDropdown()"
      >
        <div class="d-flex align-items-center justify-content-center p-3">
          <p>We couldn’t find what you were looking for.</p>
        </div>
        <img class="dropdown-img" src="assets/images/shutterstock.webp" alt="no-data" />
      </div>
    }
  </div>
</ng-template>

<ng-template #mobileTemplate>
  <input-field-with-autocomplete-mobile-view
    [items]="props.autocompleteOptions$ | async"
    (selectValue)="selectOption($event)"
    (hide)="hideModal()"
  />
</ng-template>
